import './styles.scoped.css'
import {Typography, TextField, FormControl, Select, MenuItem, Button, IconButton, FormHelperText} from '@mui/material'
import {usStates} from '../../../../utils/helpers'
import {Controller} from 'react-hook-form'
import {Add, Delete} from '@mui/icons-material'
import {useFieldArray} from 'react-hook-form'
import {AddressAutocompleteField} from '../../../../components'

export default ({form}) => {
    const {
        fields: primaryPhoneNumberFields,
        append: appendPrimaryPhoneNumber,
        remove: removePrimaryPhoneNumber,
    } = useFieldArray({control: form?.control, name: 'primaryPhoneNumbers'})
    const primaryPhoneNumberTypes = [
        {key: 'mobile', value: 'Mobile'},
        {key: 'work', value: 'Work'},
        {key: 'home', value: 'Home'},
    ]

    const selectAddress = selected => {
        form.setValue('streetAddressLine2', '')
        form.setValue('city', selected?.city)
        form.setValue('state', selected?.state)
        form.setValue('zipCode', selected?.postcode)
    }

    return (
        <>
            <Typography variant="overline" color="text.secondary">
                CAREGIVER CONTACT
            </Typography>
            <br />
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Phone Number{' '}
                <Typography variant="inputLabel" color="error">
                    *
                </Typography>
            </Typography>
            <div className="form">
                <FormControl style={{minWidth: 155}}>
                    <Controller
                        {...form.register(`primaryPhoneNumberType`)}
                        control={form.control}
                        render={({field}) => (
                            <Select
                                {...field}
                                value={field.value ?? 'mobile'}
                                onChange={e => field.onChange(e.target.value)}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: 300,
                                        },
                                    },
                                }}>
                                {primaryPhoneNumberTypes.map(item => (
                                    <MenuItem key={item?.key} value={item?.key}>
                                        {item?.value}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                    />
                </FormControl>
                <TextField
                    placeholder="Enter your phone number"
                    fullWidth
                    {...form.register('primaryPhoneNumber')}
                    error={!!form.formState.errors['primaryPhoneNumber']}
                    helperText={form.formState.errors['primaryPhoneNumber']?.message}
                />
            </div>
            {primaryPhoneNumberFields.map((field, index) => (
                <div key={field.id} style={{marginTop: -14}}>
                    <br />
                    <br />
                    <Typography variant="inputLabel" color="text.secondary">
                        Phone Number
                    </Typography>
                    <div className="form">
                        <FormControl style={{minWidth: 155}}>
                            <Controller
                                {...form.register(`primaryPhoneNumbers.${index}.type`)}
                                control={form.control}
                                render={({field}) => (
                                    <Select
                                        {...field}
                                        value={field.value ?? 'mobile'}
                                        onChange={e => field.onChange(e.target.value)}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 300,
                                                },
                                            },
                                        }}>
                                        {primaryPhoneNumberTypes.map(item => (
                                            <MenuItem key={item?.key} value={item?.key}>
                                                {item?.value}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                            />
                        </FormControl>
                        <TextField
                            placeholder="Enter your phone number"
                            fullWidth
                            {...form.register(`primaryPhoneNumbers.${index}.number`)}
                            error={!!form.formState.errors?.primaryPhoneNumbers?.[index]?.number}
                            helperText={form.formState.errors?.primaryPhoneNumbers?.[index]?.number?.message}
                        />
                        <IconButton onClick={() => removePrimaryPhoneNumber(index)}>
                            <Delete color="error" />
                        </IconButton>
                    </div>
                </div>
            ))}
            <br />
            <br />
            <Button variant="text" startIcon={<Add />} onClick={() => appendPrimaryPhoneNumber({value: ''})}>
                Add Phone Number
            </Button>
            <br />
            <hr className="line" />
            <br />
            <Typography variant="overline" color="text.secondary">
                ADDRESS
            </Typography>
            <br />
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Street Address Line 1{' '}
                <Typography variant="inputLabel" color="error">
                    *
                </Typography>
            </Typography>
            <AddressAutocompleteField
                control={form.control}
                name="streetAddressLine1"
                error={!!form.formState.errors['streetAddressLine1']}
                helperText={form.formState.errors['streetAddressLine1']?.message}
                onSelect={selectAddress}
            />
            <br />
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Street Address Line 2
            </Typography>
            <TextField placeholder="Enter your street address line 2" fullWidth {...form.register('streetAddressLine2')} />
            <br />
            <br />
            <div className="form">
                <div className="form-left">
                    <Typography variant="inputLabel" color="text.secondary">
                        City{' '}
                        <Typography variant="inputLabel" color="error">
                            *
                        </Typography>
                    </Typography>
                    <TextField
                        placeholder="Enter your city"
                        fullWidth
                        {...form.register('city')}
                        error={!!form.formState.errors['city']}
                        helperText={form.formState.errors['city']?.message}
                    />
                </div>
                <div className="form-right">
                    <Typography variant="inputLabel" color="text.secondary">
                        State{' '}
                        <Typography variant="inputLabel" color="error">
                            *
                        </Typography>
                    </Typography>
                    <FormControl fullWidth error={!!form.formState.errors['state']}>
                        <Controller
                            {...form.register('state')}
                            control={form.control}
                            render={({field}) => (
                                <Select
                                    {...field}
                                    value={field.value ?? ''}
                                    onChange={e => field.onChange(e.target.value)}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 300,
                                            },
                                        },
                                        anchorOrigin: {
                                            vertical: 'top',
                                            horizontal: 'left',
                                        },
                                        transformOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        },
                                    }}
                                    displayEmpty
                                    renderValue={selected => {
                                        if (selected === '') {
                                            return <span style={{color: '#aaa'}}>Select your state</span>
                                        }
                                        return selected
                                    }}>
                                    {usStates.map(item => (
                                        <MenuItem key={item} value={item}>
                                            {item}
                                        </MenuItem>
                                    ))}
                                </Select>
                            )}
                        />
                        <FormHelperText>{form.formState.errors['state']?.message}</FormHelperText>
                    </FormControl>
                </div>
            </div>
            <br />
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Zip Code{' '}
                <Typography variant="inputLabel" color="error">
                    *
                </Typography>
            </Typography>
            <TextField
                placeholder="Enter your zip code"
                fullWidth
                {...form.register('zipCode')}
                error={!!form.formState.errors['zipCode']}
                helperText={form.formState.errors['zipCode']?.message}
            />
            <br />
        </>
    )
}
